module.exports = __webpack_public_path__ + "static/1024px-Cammeray_Tunks_Park-cropped-226d8a561e2a7d838c33a0fef3160c4b.jpg";